import { createTableColumn } from '@fluentui/react-components'

import { RestSchemas } from '@/contexts/QueryProvider'
import { RowActionsMenu } from './RowActionsMenu'
import { OrgNameCellContent } from './OrgNameCellContent'
import { ProjectsCellContent } from './ProjectsCellContent'
import { TeamsCellContent } from './TeamsCellContent'
import { UsersCellContent } from './UsersCellContent'
import { WorkspacesCellContent } from './WorkspacesCellContent'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export const subscriptionTableColumns = [
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'name',
    compare: (a, b) => {
      return a.name.localeCompare(b.name)
    },
    renderHeaderCell: () => {
      return 'Name'
    },
    renderCell: (item) => <OrgNameCellContent item={item} />,
  }),
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'users',
    compare: (a, b) => {
      return a.users - b.users
    },
    renderHeaderCell: () => {
      return 'Users'
    },
    renderCell: (item) => <UsersCellContent item={item} />,
  }),
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'projects',
    compare: (a, b) => {
      return a.projects - b.projects
    },
    renderHeaderCell: () => {
      return 'Projects'
    },
    renderCell: (item) => <ProjectsCellContent item={item} />,
  }),
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'teams',
    compare: (a, b) => {
      return a.projectTeams - b.projectTeams
    },
    renderHeaderCell: () => {
      return 'Teams'
    },
    renderCell: (item) => <TeamsCellContent item={item} />,
  }),
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'workspaces',
    compare: (a, b) => {
      return a.workspaces - b.workspaces
    },
    renderHeaderCell: () => {
      return 'Workspaces'
    },
    renderCell: (item) => <WorkspacesCellContent item={item} />,
  }),
  createTableColumn<MessagesSubscriptionsOrganisationSummary>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => {
      return <RowActionsMenu org={item} />
    },
  }),
]
